export const API_BASE_URL =

  "https://api.npskudlu.com/api/v1/";



export const API_PATHS = {

  login: "admin/login",

  //gallery
  addGallery:"admin/add-gallery",
  getGallery:"admin/get-gallery",
  editGallery:"admin/edit-gallery",
  deleteGallery:"admin/delete-gallery",


    //activity
  addActivity:"admin/add-activity",
  getActivity:"admin/get-activity",
  editActivity:"admin/edit-activity",
  deleteActivity:"admin/delete-activity",


    //activity
  addDocument:"admin/add-document",
  getDocument:"admin/get-document",
  editDocument:"admin/edit-document",
  deleteDocument:"admin/delete-document",

  //upload
  upload:"admin/upload",


  getAcademics:"admin/get-academics",
  editAcademics:"admin/edit-academics",

  getGeneralInfo:"admin/get-general-info",
  editGeneralInfo:"admin/edit-general-info",  

  getStaff:"admin/get-staff",
  editStaff:"admin/edit-staff",

  getInfrastructure:"admin/get-infrastructure",
  editInfrastructure:"admin/edit-infrastructure",

       

}